import Vue from 'vue'
import Router from 'vue-router'
import PageNotFound from '../views/pages/error-page/404.vue'

Vue.use(Router)

const getRoute = () => {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '*',
        name: 'PageNotFound',
        component: PageNotFound
      }
    ]
  })
}

export default getRoute
